import Vue from "vue";
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap-vue/dist/bootstrap-vue.css'
import SmoothReflow from '@/_oad_repo/components/SmoothReflow'

Vue.use(BootstrapVue)
Vue.component('SmoothReflow', SmoothReflow)

